import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import './icon.scss';

class IconProfile extends React.Component {
  state = {
    opacity: 1,
    focus: false,
    borderStyle: '',
  };

  UNSAFE_componentWillReceiveProps = newProps => {
    const id = _.get(newProps, 'id', 0);
    const selected = _.get(newProps, 'selected', 0);
    const opacity = _.get(newProps, 'opacity', false);
    const focus = _.get(newProps, 'focus', false);
    if (selected !== Number(id) && selected !== 0 && opacity) {
      this.setState({ opacity: 0.4 });
    } else {
      this.setState({ opacity: 1 });
    }
    if (selected === Number(id) && selected !== 0 && focus) {
      this.setState({ focus: true });
    } else {
      this.setState({ focus: false });
    }
  };

  handleClick = () => {
    if (typeof this.props.onClick === 'function') {
      const { id } = this.props;
      this.props.onClick(id);
    }
  };

  handleError = e => {
    this.setState({ borderStyle: 'border'});
    e.target.onerror = false;
    e.target.src = '';
  };

  render() {
    const { opacity, focus, borderStyle } = this.state;
    const { src, hover, width, height } = this.props;
    const classHover = hover ? 'hover' : '';
    const classSelected = focus ? 'selected' : '';
    return (
      <div
        className={`icon img-icon ${borderStyle}`}
        style={{ width, height }}
        onClick={this.handleClick}
      >
        <img
          className={`img-icon ${classHover} ${classSelected}`}
          alt="Profile"
          style={{ opacity }}
          src={src}
          onError={e => {
            this.handleError(e);
          }}
        />
      </div>
    );
  }
}

IconProfile.propTypes = {
  src: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  hover: PropTypes.bool,
  selected: PropTypes.number,
  onClick: PropTypes.func,
};

export default IconProfile;
